var slider_new;
var thumb_slider_new;

(function(){

  if(document.querySelectorAll('.index-template').length) {
    
//     Homepage collection product title section
    function sectionTitle() {
      document.querySelectorAll('.section-title').forEach(function(ele){
        var sectionId = ele.dataset.id;
        var orgHtml = ele.outerHTML;
        if(document.querySelectorAll(`#shopify-section-i${sectionId}`).length == 0 && window.innerWidth < 768) {
          var newHtml = `<div class='shopify-section index-section-title slide-visibled visible-xs' id='shopify-section-i${sectionId}'>${orgHtml}</div>`;
          document.getElementById(`shopify-section-${sectionId}`).insertAdjacentHTML('beforebegin', newHtml);
          ele.classList.add('hidden-xs');
          document.getElementById(`shopify-section-i${sectionId}`).querySelector('.section-title').classList.remove('hidden-xs');
        } else {
          if(document.querySelectorAll(`#shopify-section-i${sectionId}`).length > 0 && window.innerWidth > 767) {
            document.querySelector(`#shopify-section-i${sectionId}`).remove();
          }
        }
      });
    }
    
   /* function sectionTitle() {
      document.querySelectorAll('.section-title').forEach(function(ele){
        var sectionId = ele.dataset.id;
        var orgHtml = ele.outerHTML;
        if(document.querySelectorAll(`#shopify-section-i${sectionId}`).length == 0 && window.innerWidth < 2560) {
          var newHtml = `<div class='shopify-section index-section-title slide-visibled' id='shopify-section-i${sectionId}'>${orgHtml}</div>`;
          document.getElementById(`shopify-section-${sectionId}`).insertAdjacentHTML('beforebegin', newHtml);
          ele.classList.add('title-hidden');
//           document.getElementById(`shopify-section-i${sectionId}`).querySelector('.section-title').classList.remove('hidden-xs');
        } 
      });
    }*/

    sectionTitle();
    window.addEventListener('resize', function(event) {
      sectionTitle();
    }, true);

    document.querySelectorAll('.collection-list').forEach(function(ele){
      ele.querySelector('.row').scrollLeft = ele.querySelector('.collection-item').offsetWidth
    });
    
//     homepage slider html layout
    document.querySelector('.index-swiper').classList.add('swiper');
    document.querySelector('.index-wrapper').classList.add('swiper-wrapper');
    document.querySelectorAll('.index-wrapper > .shopify-section').forEach(function(ele,indx){
      ele.classList.add('index-slide', 'swiper-slide', `index-slide-${indx}`);
    });

//     homepage slider initialzed
    var settings = {
      speed: 1000,
      direction: 'vertical',
      slidesPerView: 'auto',
      mousewheel: true,
    }, indexSwiper = new Swiper('.index-swiper', settings);

//     slider next slide visibile
    document.querySelector('.index-swiper').setAttribute('data-index', 0);
    document.querySelector('.index-slide-0').classList.add('slide-visibled');
    if((window.innerHeight + 60) > document.querySelector('.index-slide-0').offsetHeight) {
      document.querySelector('.index-slide-1').classList.add('slide-visibled');
      indexSwiper.update();
      console.log('update 1');
    }
    
//     homepage slide change (for up & down scroll change)
    indexSwiper.on('slideChange', function () {
      var currentIndex = parseInt(document.querySelector('.index-swiper').dataset.index);
      var changeIndex = indexSwiper.activeIndex;

      if(changeIndex > currentIndex) {
        var nextIndex = changeIndex + 1;
        if(document.querySelectorAll(`.index-slide-${nextIndex}`).length > 0) {
          if((window.innerHeight + 60) > document.querySelector(`.index-slide-${changeIndex}`).offsetHeight) {
            document.querySelector(`.index-slide-${nextIndex}`).classList.add('slide-visibled');
            indexSwiper.update();
            console.log('update 2');
            indexSwiper.setTranslate(document.querySelector('.index-swiper').getAttribute('translate'));
            indexSwiper.slideTo(changeIndex);
          }
        }
        document.querySelector('.index-swiper').dataset.index = changeIndex;
      } else {
        setTimeout(function(){
          var nextIndex = currentIndex + 1;
          if(document.querySelectorAll(`.index-slide-${nextIndex}`).length > 0) {
            document.querySelector(`.index-slide-${nextIndex}`).classList.remove('slide-visibled');
            indexSwiper.update();
            console.log('update 3');
          }
        }, 700);

        if(document.querySelector(`.index-slide-${changeIndex}`).offsetHeight > (window.innerHeight + 60)) {
          setTimeout(function(){
            document.querySelector(`.index-slide-${currentIndex}`).classList.remove('slide-visibled');
            indexSwiper.update();
            console.log('update 4');
          }, 800);
        }

        document.querySelector('.index-swiper').dataset.index = changeIndex;
        document.querySelector('body').classList.remove('blanca-sticky');
      }
      if(changeIndex > 0) {
        document.querySelector('body').classList.add('sticked');
      } else {
        document.querySelector('body').classList.remove('sticked');
      }
    });

//     homepage slider if section height is more than viewport height
    indexSwiper.on('slideResetTransitionEnd', function () {
      var activeIndex = indexSwiper.activeIndex;
      var nextIndex = indexSwiper.activeIndex + 1;
      var length = document.querySelectorAll('.index-slide').length - 1;
      if(nextIndex <= length) {
        document.querySelector(`.index-slide-${nextIndex}`).classList.add('slide-visibled');
       document.querySelector('.index-swiper').setAttribute('translate', indexSwiper.getTranslate());
        indexSwiper.update();
        console.log('update 5');
       indexSwiper.setTranslate(document.querySelector('.index-swiper').getAttribute('translate'));
      }

      if(document.querySelector(`.index-slide-${activeIndex}`).getAttribute('id') == 'shopify-section-newsletter') {
        document.querySelector('body').classList.add('blanca-sticky');
      }
    });
//     End of Homepage slider
    
  } else {
    
//     Smooth scroll
    if(!document.querySelectorAll('#fashion-i1-page').length) {
      if(window.innerWidth > 1023) {
        butter.init({
          wrapperId: 'site-wrapper',
          wrapperDamper: 0.05,
          cancelOnTouch: true
        });
      }
    }
//     End of Smooth scroll
    
  }

  document.querySelectorAll('.casa-blanca-height').forEach(function(ele){
    var windowHeight = document.getElementById('mask-hidden').offsetHeight;
    var elementheight = 140;
    if(window.innerWidth > 768) {
      elementheight = 179;
    } else if(document.querySelectorAll('.site-topbar').length > 0) {
      var elementheight = 170;  
    }

    ele.style.minHeight = (windowHeight - elementheight)+'px';
  });

  document.querySelectorAll('.single-slide').forEach(function(ele){
    var windowHeight = document.getElementById('mask-hidden').offsetHeight;
    if(window.innerWidth < 768) {
      ele.style.height  = windowHeight+'px';
    }
  });

  function popupsEvent(ele,state){
    var triggerElement = ele.dataset.element;
    var triggerClass = ele.dataset.class;

    if (state == 'open' && !(document.querySelector('body').dataset.modal == triggerElement)) {
      if(document.querySelector('body').hasAttribute('data-modal')) {
        var getRemoveElement = document.querySelector('body').dataset.modal;
        var getRemoveClass = document.querySelector(`[data-element=${getRemoveElement}]`).dataset.class;

        //         document.querySelector(`[data-element="${getRemoveElement}"]`).classList.remove('active');
        document.querySelectorAll(`[data-element="${getRemoveElement}"]`).forEach(function(ele){
          ele.classList.remove('active');
        });

        document.querySelector('body').classList.remove(getRemoveClass);
        document.querySelector(`.${getRemoveElement}`).classList.remove('showed');

        setTimeout(function(){
          ele.classList.add('active');
          document.querySelector('body').classList.add(triggerClass);
          document.querySelector('body').dataset.modal = triggerElement;
          document.querySelector(`.${triggerElement}`).classList.add('showed');
        }, 200);	
      } else {
        ele.classList.add('active');
        document.querySelector('body').classList.add(triggerClass);
        document.querySelector('body').dataset.modal = triggerElement;
        document.querySelector(`.${triggerElement}`).classList.add('showed');
      }
    } else {
      var getRemoveElement = document.querySelector('body').dataset.modal;
      if(typeof getRemoveElement !== 'undefined'){
        var getRemoveClass = document.querySelector(`[data-element=${getRemoveElement}]`).dataset.class;

        //       document.querySelector(`[data-element="${getRemoveElement}"]`).classList.remove('active');
        document.querySelectorAll(`[data-element="${getRemoveElement}"]`).forEach(function(ele){
          ele.classList.remove('active');
        });
        document.querySelector('body').classList.remove(getRemoveClass);
        delete document.querySelector('body').dataset.modal;
        document.querySelector(`.${getRemoveElement}`).classList.remove('showed');
      }
    }
  }

  document.querySelectorAll('.openpop-element').forEach(function(ele){
    ele.addEventListener('click', function(){
      popupsEvent(this, 'open');
      if(ele.classList.contains('sort-toggle')) {
        document.querySelector('html').classList.add('sort-open');
      }
    });
  });

  document.querySelectorAll('.closepop-element').forEach(function(ele){
    ele.addEventListener('click', function(){
      if(document.querySelector('body').getAttribute('data-modal') == 'sort-drawer') {
        document.querySelector('html').classList.remove('sort-open');
      }

      popupsEvent(this, 'close');
      if(ele.classList.contains('fdrawer-close')) {
        document.querySelectorAll('.filter-group').forEach(function(ele){
          ele.classList.remove('opened');
        });
      }
    });
  });

  document.querySelectorAll('.sitebar-close').forEach(function(ele){
    ele.addEventListener('click', function(){
      document.querySelector('body').classList.add('hide-bar');
      document.querySelectorAll('.casa-blanca-height').forEach(function(ele){
        var windowHeight = document.getElementById('mask-hidden').offsetHeight;
        var elementheight = 140;

        ele.style.minHeight = (windowHeight - elementheight)+'px';
      });
    });
  });

  function stickyElements() {
    if(document.querySelector('.site-topbar').offsetHeight > 0) {
      var headerTopBar = document.querySelector('.site-topbar').offsetHeight;
      if(window.scrollY > headerTopBar) {
        document.querySelector('body').classList.add('sticked');
      } else {
        document.querySelector('body').classList.remove('sticked');
      }
    }

    if(!document.querySelectorAll('#fashion-show-page').length > 0) {
      if(document.querySelectorAll('.collection-filter').length && document.querySelector('.collection-filter').offsetTop < (window.innerHeight / 2)) {
        if(window.scrollY > 60) {
          document.querySelector('body').classList.add('sticked-x');
        } else {
          document.querySelector('body').classList.remove('sticked-x');
        }
      } else {
        if(window.scrollY > (window.innerHeight / 2)) {
          document.querySelector('body').classList.add('sticked-x');
        } else {
          document.querySelector('body').classList.remove('sticked-x');
        }
      }

      if(document.querySelectorAll('.collection-filter').length) {
        var windowOffset = window.scrollY;
        var elementOffset = document.querySelector('.collection-filter').offsetTop;

        if(document.querySelector('body').classList.contains('sticked-x')) {
          windowOffset = window.scrollY + (document.querySelector('.site-xs-header').offsetHeight - 1);
        }

        if(windowOffset > elementOffset) {
          document.querySelector('body').classList.add('filter-sticked');
        } else {
          document.querySelector('body').classList.remove('filter-sticked');
        }
      }
    }
  }


  stickyElements();
  window.addEventListener('scroll',(event) => {
    stickyElements();
  });

  document.querySelectorAll('.xnav-toggle').forEach(function(ele){
    ele.addEventListener('click', function(){
      if(ele.hasAttribute('data-nav')) {
        var navLevel = ele.dataset.nav;
        document.querySelector('.site-xs-nav').classList.add(`${navLevel}-opened`);
        ele.parentNode.nextElementSibling.classList.add('opened');
      }
    });
  });

  document.querySelectorAll('.xnav-back').forEach(function(ele){
    ele.addEventListener('click', function(){
      var navLevel = ele.dataset.nav;
      document.querySelector('.site-xs-nav').classList.remove(`${navLevel}-opened`);
      document.querySelectorAll(`.xnav-${navLevel}`).forEach(function(e){
        e.classList.remove(`opened`);
      });
    });
  });

  document.querySelectorAll('.search-clear').forEach(function(ele){
    ele.addEventListener('click', function(){
      document.querySelector('.search-input').value = '';
      document.querySelector('.search-results').innerHTML = '';
      document.querySelector('.search-results').style.display = 'none';
      document.querySelector(".site-nav-search").classList.remove("searched");
    });
  });

  document.querySelectorAll('.section-scroll').forEach(function(ele){
    ele.addEventListener('click', function(){
      var target = ele.dataset.id;
      if(document.querySelectorAll('.index-template').length && document.querySelectorAll('.index-section-title').length) {
        indexSwiper.slideTo(indexSwiper.activeIndex+1);
      } else {
        var offset = document.querySelector(`#${target}`).offsetTop - (document.querySelector('.site-xs-header').offsetHeight + 20);
        window.scroll({
          top: offset,
          behavior: 'smooth'
        });
      }
    });
  });

  document.querySelectorAll('.filter-toggle').forEach(function(ele){
    ele.addEventListener('click', function(){
      globofilter.toggleCanvas();
    });
  });

  document.querySelectorAll('.view-toggle').forEach(function(ele){
    ele.addEventListener('click', function(){
      document.querySelector('.collection-products').classList.toggle('v2');
      document.querySelector('.collection-products').classList.toggle('v3');
    });
  });

  document.querySelectorAll('.video-play').forEach(function(ele){
    ele.addEventListener('click', function(e){
      var videoSrc = ele.dataset.src;
      document.querySelector('body').classList.add('vpop-opened');
      document.getElementById('video-pop-ele').querySelector('source').setAttribute('src', videoSrc);
      document.getElementById('video-pop-ele').load();
      document.getElementById('video-pop-ele').play();
    });
  });

  document.querySelectorAll('.video-popclose').forEach(function(ele){
    ele.addEventListener('click', function(){
      document.querySelector('body').classList.remove('vpop-opened');
      document.getElementById('video-pop-ele').pause();
      document.getElementById('video-pop-ele').querySelector('source').setAttribute('src', '');
    });
  });

  if(document.querySelectorAll('.single-slider').length && document.querySelector('.single-slider').dataset.length > 1) {
    if(document.querySelectorAll('.thumb-slider').length) {
      var thumbSlider = new Swiper('.thumb-slider', {
        direction: "vertical",
        slidesPerView: 2,
      });

      var singleSlider = new Swiper('.single-slider', {
        slidesPerView: 1,
        thumbs: {
          swiper: thumbSlider,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: "fraction",
        },
      });

      singleSlider.on('slideChange', function () {
        var currentIndex = singleSlider.previousIndex;
        var activeIndex = singleSlider.activeIndex;
        //console.log(activeIndex);

        if(activeIndex > currentIndex) {
          thumbSlider.slideToLoop(activeIndex);
        } else {
          thumbSlider.slideToLoop(activeIndex - 1);
        }
      });
    } else {
      var singleSlider = new Swiper('.single-slider', {
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-nexts',
          prevEl: '.swiper-button-prevs',
        },
        pagination: {
          el: '.swiper-paginations',
          type: "fraction",
        },
      });
    }
  }

  thumb_slider_new = thumbSlider;
  slider_new = singleSlider;

  document.querySelectorAll('.zimg-pop-trigger').forEach(function(ele){
    ele.addEventListener('click', function(){
      var imageSrc = ele.dataset.src;
      if(window.innerWidth < 768) {
        var imageWidth = ele.dataset.width;
        var imageHeight = ele.dataset.height;
        var aspectRatio = 1024 * (imageHeight / imageWidth);
        var scrollLeft = (1024 - window.innerWidth) / 2;

        document.querySelector('.zimage-wrap').style.minHeight = aspectRatio+'px';
        document.querySelector('.zimage-popbox').scrollTop = 0;
        document.querySelector('.zimage-popbox').scrollLeft = scrollLeft;
      }
      document.querySelector('body').classList.add('zipop-opened');
      document.querySelector('.zimage-pop-ele').setAttribute('src', imageSrc);
    });
  });

  document.querySelectorAll('.zimage-pop-ele').forEach(function(ele){
    ele.addEventListener('click', function(){
      document.querySelector('body').classList.remove('zipop-opened');
      setTimeout(function(){
        document.querySelector('.zimage-pop-ele').setAttribute('src', '');
      }, 300);
    });
  });

  document.querySelectorAll('.zimage-popclose').forEach(function(ele){
    ele.addEventListener('click', function(){
      document.querySelector('body').classList.remove('zipop-opened');
      setTimeout(function(){
        document.querySelector('.zimage-pop-ele').setAttribute('src', '');
      }, 300);
    });
  });

  if(document.querySelectorAll('.filter-xstoggle').length) {
    document.querySelector('.filter-xstoggle').addEventListener('click', function(){
      this.classList.toggle('active');
      document.querySelector('.filters-drawer').classList.toggle('xsopened');
    });
  }

  document.querySelectorAll('.filter-title').forEach(function(element){
    element.addEventListener('click', function(){
      var parentEle = element.parentNode;

      if(parentEle.classList.contains('opened')) {
        parentEle.classList.remove('opened');
      } else {
        var el = document.querySelectorAll('.filter-group');
        for (var i = 0; i < el.length; i++) {
          el[i].classList.remove('opened');
        }
        parentEle.classList.add('opened');
      }
    });
  });

  document.querySelectorAll('.filter-back').forEach(function(element){
    element.addEventListener('click', function(e){
      (element.parentNode).parentNode.classList.remove('opened')
    });
  });

  document.querySelectorAll('.filter-group').forEach(function(element){
    element.addEventListener('click', function(e){
      e.stopPropagation();
    });
  });

  document.querySelectorAll('.filter-drawer').forEach(function(element){
    element.addEventListener('click', function(e){
      e.stopPropagation();
    });
  });

  document.addEventListener("click", function(){
    var elems = document.querySelectorAll('.filter-group');
    [].forEach.call(elems, function(el) {
      el.classList.remove('opened');
    });
  });

  function tableWrap() {
    document.querySelectorAll('table').forEach(function(ele){
      var orgHtml = ele.outerHTML;
      var newHtml = "<div class='table-wrap'>" + orgHtml + "</div>";
      ele.insertAdjacentHTML('afterend', newHtml);
      ele.remove();
    });
  }
  tableWrap();

  document.querySelectorAll('.accordian-title').forEach(function(element){
    element.addEventListener('click', function(){
      if(element.classList.contains('active')) {
        element.classList.remove('active');
        element.nextElementSibling.style.display = "none";
      } else {
        var el = element.closest('.accordian').querySelectorAll('.accordian-title');
        for (var i = 0; i < el.length; i++) {
          el[i].classList.remove('active');
          el[i].nextElementSibling.style.display = "none";
        }
        element.classList.add('active');
        element.nextElementSibling.style.display = "block";
      }
    });
  });

// Couldn't see the slider within source code
  // if(window.innerWidth < 768) {
  //   var collectionSlider = new Swiper('.collection-slider', {
  //     loop: true,
  //     slidesPerView: 'auto',
  //     centeredSlides: true,
  //   });
  // }

  
   function productSlider() {

    
 let productSliders = document.querySelectorAll('.product-slider')
 let prevArrow = document.querySelectorAll('.prev')
let nextArrow = document.querySelectorAll('.next')
     
productSliders.forEach((sliderItem, index)=>{
let sliderLength = sliderItem.children[0].children.length
 let result = (sliderLength > 1) ? true : false;
  if(window.innerWidth < 768) {
     const swiper99 = new Swiper(sliderItem, {
    observer: true, 
observeParents: true,
          slidesPerView: 1,
            pagination: false,
          wrapper: ".swiper-wrapper1",
     loop: false,
     navigation: {
         nextEl: nextArrow[index],
         prevEl: prevArrow[index],
     },
     speed: 1000,
   }); 
    } else {
    const swiper99 = new Swiper(sliderItem, {
    observer: true, 
observeParents: true,
 slidesPerView: 3,
  pagination: false,
    wrapper: ".swiper-wrapper1",
     loop: true,
     navigation: {
         nextEl: nextArrow[index],
         prevEl: prevArrow[index],
     },
     speed: 1000,
   }); 
    }
  
 });
 }
  
  $(document).ready(function () {
    window.setTimeout(function () { productSlider(); }, 10);
});
// productSlider();
  //     window.addEventListener('resize', function(event) {
  // productSlider();
  //   }, true);
  
//    const productSlider = ()=>{
//  let productSliders = document.querySelectorAll('.product-slider')
//  let prevArrow = document.querySelectorAll('.prev')
// let nextArrow = document.querySelectorAll('.next')
// productSliders.forEach((slider, index)=>{
// let sliderLength = slider.children[0].children.length
//  let result = (sliderLength > 1) ? true : false
//   const swiper = new Swiper(slider, {
//         slidesPerView: 'auto',
//             pagination: false,
//      loop: true,
//      navigation: {
//          nextEl: nextArrow[index],
//          prevEl: prevArrow[index],
//      },
//      speed: 1000,
//    }); 
//  });
//  }
// window.addEventListener('load', productSlider);
    
  // var productSlider = new Swiper('.product-slider', {
  //   slidesPerView: 'auto',
  //   loop: true,
  //   pagination: false,
  //   navigation: 
  //   {
  //     nextEl: '.swiper-button-next4',
  //     prevEl: '.swiper-button-prev4',
  //   },
  // });

  document.querySelectorAll('.banner-img-txt').forEach(function(ele){
    if(ele.classList.contains('swiper')) {
      if(ele.dataset.autoplay == "true"){
        var bannerSlider = new Swiper(ele, {
          slidesPerView: 1,
          loop: true,
          autoplay: {
            enabled: true,
            delay: 5000,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      }else{
        var bannerSlider = new Swiper(ele, {
          slidesPerView: 1,
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      }
    }
  });

  document.querySelectorAll('.fshn-view-toggle').forEach(function(ele){
    ele.addEventListener('click', function(){
      ele.classList.toggle('opened');
    });
  });

  document.querySelectorAll('.fshn-view-list li').forEach(function(ele){
    ele.addEventListener('click', function(){
      var viewClass = ele.dataset.view;
      document.querySelectorAll('.fshn-view-list li').forEach(function(e){
        e.classList.remove('active');
      });
      ele.classList.add('active');
      document.querySelector('.fashion-ctg-list').classList.remove('view-1', 'view-2');
      document.querySelector('.fashion-ctg-list').classList.add(viewClass);
    });
  });

  document.querySelectorAll('.accordian-details summary').forEach(function(element){
    element.addEventListener('click', function(){
      ele = element.parentElement;
      if(!ele.hasAttribute('open')) {
        var el = element.closest('div').querySelectorAll('details');
        for (var i = 0; i < el.length; i++) {
          el[i].removeAttribute('open');
        }
      }
    });
  });
  
  
  
  
  function unsticky() {
  
  var windowOffsets = window.scrollY + $(".site-footer").height() + $("#shopify-section-newsletter").height();
  var elementOffsets = document.querySelector('.site-footer').offsetTop;
// console.log('dff',windowOffsets,elementOffsets);

  if(windowOffsets > elementOffsets) {
    document.querySelector('body').classList.add('ssticked');
  } else {
    document.querySelector('body').classList.remove('ssticked');
  }
}


  unsticky();
  window.addEventListener('scroll',(event) => {
    unsticky();
  });
  
  
  
})()

/* Search drawer */
if(document.querySelector(".search-input")){
  document.querySelector(".search-input").addEventListener("keyup", function(){
    const keyword = this.value;

    if(keyword.length > 3 && keyword.trim() != ''){
      document.querySelector(".site-nav-search").classList.add("searched");
      document.querySelector(".search-results").style.display = 'block';
      const url = "/search?view=result&q="+keyword+"*&type=product";
      fetch(url)
      .then(response_data => response_data.text())
      .then(response => {
        var parse = new DOMParser().parseFromString(response, 'text/html');
        document.querySelector(".search-results").innerHTML = parse.querySelector(".search_result_data").innerHTML;
      });
    }else{
      if(keyword.length == 0){
        document.querySelector(".site-nav-search").classList.remove("searched");
        document.querySelector(".search-results").style.display = 'none';
        document.querySelector(".search-results").innerHTML = '';
      }else{
        document.querySelector(".site-nav-search").classList.add("searched");
        document.querySelector(".search-results").style.display = 'block';
        document.querySelector(".search-results").innerHTML = '<div class="total_result">No results could be found</div>';
      }
    }
  });
}


$(document).ready(function(){

  var email_regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  /* Newsletter form validation */
  $(".newsletter_btn").on("click", function(){
    var form = $(this).parents("form");
    var name = form.find(".name");
    var email = form.find(".email");
    var err_txt = form.find(".newsletter_error");
    err_txt.text("");

    if(name.val() == ''){
      err_txt.text("Enter your name");
      name.focus();
      return false;
    }else if(email.val() == ''){
      err_txt.text("Enter your email address");
      email.focus();
      return false;
    }else if(!email_regex.test(email.val())) {
      err_txt.text("Enter your valid email address");
      email.focus();
      return false; 
    }else{
      err_txt.text("");
      return true;
    }
  });

  /* Contact us form validation */
  $(".contact_us_btn").on("click", function(){
    var form = $(this).parents("form");
    var name = form.find(".name");
    var email = form.find(".email");
    var message = form.find(".message");
    var err_txt = form.find(".contact_error");
    err_txt.text("");

    if(name.val() == ''){
      err_txt.text("Enter your name");
      name.focus();
      return false;
    }else if(email.val() == ''){
      err_txt.text("Enter your email address");
      email.focus();
      return false;
    }else if(!email_regex.test(email.val())) {
      err_txt.text("Enter your valid email address");
      email.focus();
      return false; 
    }else if(message.val() == ''){
      err_txt.text("Enter your message");
      message.focus();
      return false;
    }else{
      err_txt.text("");
      return true;
    }
  });

  /* Reset password and Activate account page validation */
  $(".reset_password_button, .activate_acc_btn").on("click", function(){
    var form = $(this).parents("form");
    var password = form.find(".password");
    var conf_password = form.find(".conf_password");
    var err_txt = form.find(".error_msg");
    err_txt.text("");

    if(password.val() == ''){
      err_txt.text("Enter your new password");
      password.focus();
      return false;
    }else if(conf_password.val() == ''){
      err_txt.text("Enter your confirm password");
      conf_password.focus();
      return false;
    }else if(password.val() != conf_password.val()){
      err_txt.text("Confirm password does not match with password");
      conf_password.val('');
      conf_password.focus();
      return false;
    }else{
      err_txt.text("");
      return true;
    }
  });

  /* Login page validation */
  $(".login_btn").click(function(){
    var form = $(this).parents("form");
    var email = form.find(".email");
    var password = form.find(".password");
    var err_txt = form.find(".login_form_error");
    if(form.find(".form-error")){
      form.find(".form-error").text('');
    }

    if(email.val() == ''){
      err_txt.text("Enter your email address");
      email.focus();
      return false;
    }else if(!email_regex.test(email.val())) {
      err_txt.text("Enter your valid email address");
      email.focus();
      return false; 
    }else if(password.val() == ''){
      err_txt.text("Enter your password");
      password.focus();
      return false;
    }else{
      err_txt.text("");
      return true;
    }
  });

  /* Reset password form validation */
  $(".reset_password_btn").on("click", function(){
    var form = $(this).parents("form");
    var email = form.find(".reset_pass_email");
    var err_txt = form.find(".reset_pass_error");
    if(form.find(".form-error")){
      form.find(".form-error").text('');
    }

    if(email.val() == ''){
      err_txt.text("Enter your email address");
      email.focus();
      return false;
    }else if(!email_regex.test(email.val())) {
      err_txt.text("Enter your valid email address");
      email.focus();
      return false; 
    }else{
      err_txt.text("");
      return true;
    }
  });

  /* Register form validation */
  $(".register_btn").on("click", function(){
    var form = $(this).parents("form");
    form.find(".register_error").text("");
    var fname = form.find(".fname");
    var lname = form.find(".lname");
    var email = form.find(".email");
    var password = form.find(".password");
    var err_txt = form.find(".register_error");
    if(form.find(".form-error")){
      form.find(".form-error").text('');
    }

    if(fname.val() == ''){
      err_txt.text("Enter your first name");
      fname.focus();
      return false;
    }else if(lname.val() == ''){
      err_txt.text("Enter your last name");
      lname.focus();
      return false;
    }else if(email.val() == ''){
      err_txt.text("Enter your email address");
      email.focus();
      return false;
    }else if(!email_regex.test(email.val())) {
      err_txt.text("Enter your valid email address");
      email.focus();
      return false; 
    }else if(password.val() == ''){
      err_txt.text("Enter your password");
      password.focus();
      return false;
    }else if(password.val() != '' && password.val().length < 5){
      err_txt.text("Password is too short (minimum is 5 characters)");
      password.focus();
      return false;
    }else{
      err_txt.text("");
      return true;
    }
  });

  /* Add address and Edit address form validation */
  $(".add_address_btn, .update_address_btn").click(function(){
    var form = $(this).parents("form");
    var fname = form.find(".fname");
    var lname = form.find(".lname");
    var address1 = form.find(".add1");
    var city = form.find(".city");
    var country = form.find(".country");
    var zip_code = form.find(".zip_code");
    var contact = form.find(".contact");
    var err_txt = form.find(".error_msg");
    err_txt.text("");

    if(fname.val() == ''){
      err_txt.text("Enter your first name");
      fname.focus();
      return false;
    }else if(lname.val() == ''){
      err_txt.text("Enter your last name");
      lname.focus();
      return false;
    }else if(address1.val() == ''){
      err_txt.text("Enter your address");
      address1.focus();
      return false;
    }else if(city.val() == ''){
      err_txt.text("Enter your city name");
      city.focus();
      return false;
    }else if(country.val() == "---"){
      err_txt.text("Select your country from country selector");
      country.focus().click();
      return false;
    }else if(zip_code.val() == ''){
      err_txt.text("Enter your postal / zip code");
      zip_code.focus();
      return false;
    }else if(contact.val() == ''){
      err_txt.text("Enter your contact number");
      contact.focus();
      return false;
    }else{
      err_txt.text("");
      return true;
    }
  });

  /* quantity update */
  $(document).on("click", ".qty_update", function(){
    $(this).parents(".cdrawer-info").find(".soldout_msg").html('');
    var value = $(this).parent(".cart-qty").find(".qty").val();
    var line_index = $(this).parent(".cart-qty").find(".qty").data("index");
    var data_max = $(this).parent(".cart-qty").find(".qty").data("max");
    var data_title = $(this).parent(".cart-qty").find(".qty").data("title");

    if($(this).data("name") == 'plus'){
      value++;
    }else{
      value--;
    }

    if(data_max >= value){
      $(this).parent(".cart-qty").find(".qty").val(value);
      update_drawer(line_index, value);
    }else{
      $(this).parents(".cdrawer-info").find(".soldout_msg").html('<p>All '+data_max+' '+data_title+' product are in your cart.</p>');
    }
  });

  /* Cart drawer item remove */
  $(document).on("click", ".cart-remove", function(event){
    event.preventDefault();
    var line_index = $(this).data("index");
    update_drawer(line_index, 0);
  });

  /* Update cart */
  function update_drawer(line_index, qty){
    $.ajax({
      type:"POST",
      url:"/cart/change.js",
      data: { "id":line_index, "quantity":qty },
      dataType:'json',
      success:function(data){
        cart_drawer();
      }
    });
  }

  /* Sorting */
   $('input.search-input').on("change", ".sort_option", function(){
     $(".closepop-element").trigger("click");
  });

  $(".swatch-list input[type='radio']").on("click", function(){
    var value = $(this).val();
    var index = $(this).parents(".swatch").data("option");
    $(".single-option-selector[data-option='"+index+"'] option[value='"+value+"']").prop("selected", true);
    $(".single-option-selector[data-option='"+index+"'] option[value='"+value+"']").trigger("change");
  });

  /* Add to cart */
  $(".add_to_cart_btn").on("click", function(e){
    e.preventDefault();
    $(this).parents("form").find(".soldout_msg").html('');
    var obj = $(this);

    $.ajax({
      type:"POST",
      url:"/cart/add.js",
      dataType: 'json',
      data:$(this).parents("form").serialize(),
      success:function(data){
        cart_drawer();
        setTimeout(function(){
          $(".cart-drawer").addClass("showed");
          $("body").addClass("drawer-opened").attr("data-modal","cart-drawer");
        }, 500);
      },
      error:function(xhr, status, error){
        obj.parents("form").find(".soldout_msg").html("<p>"+xhr.responseJSON.description+"</p>");
      }
    });
  });
});

$(window).on("load", function(){
  /* if contact form submit success then scroll to success message */
  var header_top = $(".site-header").height();
  if($(".news-success").length > 0){
    setTimeout(function(){
      var news_succ = $(".news-success").offset().top;
      var total_succ = parseInt(news_succ-header_top);

      $('html, body').animate({
        scrollTop: total_succ
      }, 600);

    }, 100);
  }

  /* Product Recommendations */
  if(document.querySelector(".related-products")){
    var url = document.querySelector(".related-products").dataset.url;
    fetch(url)
    .then(response_data => response_data.text())
    .then(data => {
      var html = new DOMParser().parseFromString(data, 'text/html');
      if(html.querySelector(".product-item") != null){
        document.querySelector(".related-products").innerHTML = html.querySelector(".related-products").innerHTML;
      }else{
        document.querySelector(".related-products").remove();
      }
    });
  }

  //$(".shopify-section").html
});

/* cart drawer */
function cart_drawer(){
  $.ajax({
    type:'GET',
    url:'/',
    dataType:'html',
    success:function(cart){
      var cart_body = $(cart).find(".cdrawer-wrapper").html();
      $(".cdrawer-wrapper").html(cart_body);
    }
  });
}

function new_update(var_img){
  if($(".single-slide").length > 0){
    $(".single-slide").each(function(index){
      var data_img = $(this).data("img");
      var img = var_img;
      if(img.includes(data_img) == true){
        if($(".thumb-slide").length > 0){
          thumb_slider_new.slideToLoop(index);
        }
        slider_new.slideToLoop(index);
      }
    });
  }
}

$(window).scroll(function() {
  if ($('.blanca-svg').offset().top + $('.blanca-svg').outerHeight() > $('.site-footer').offset().top) {
    $('body').addClass('hidden');
  } else {
    $('body').removeClass('hidden');
  }
});

function isInView(el) {
   let box = el.getBoundingClientRect();
   return box.top <= window.innerHeight;
}

window.addEventListener("scroll", function() {
  var footer = document.getElementById("shopify-section-footer");
  var visible = isInView(footer);
  var urls = document.querySelector("body");
    if(visible) {
      urls.classList.add("animate__fadeIn");
    } else {
      urls.classList.remove("animate__fadeIn");
    }
});

$(document).ready(function(){
  
  
  $(window).scroll(function () {
    $('.site-footer').each(function (i) {
      var bottom_of_object = $(this).offset().top + ($(this).outerHeight() * 0.3);
      var bottom_of_window = $(window).scrollTop() + $(window).height();
      if (bottom_of_window > bottom_of_object) {
        $('body').addClass('animated');
      } else {
    
    $('body').removeClass("animated");	
    }
    });
  
  });
  
});


$(window).scroll(function() {
  var T = $(window).scrollTop() + $(window).height();
  T > $(".site-footer").offset().top ? $("body").addClass("unsticky") : $("body").removeClass("unsticky");
});


$(document).ready(function() {
$(window).scroll(function() {
  setTimeout(function() {
    var top_of_element = $(".site-footer").offset().top;
    var bottom_of_element = $(".site-footer").offset().top + $(".site-footer").outerHeight();
    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var top_of_screen = $(window).scrollTop();

    if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
        $('body').addClass('animated');
    } else {
        $('body').removeClass('animated');
    }
  }, 500);
});
});